import {
  ITaskTypePayload,
  ITaskTypeResponse,
  ITaskTypesResponse
} from 'types/taskType';
import request from './index';
import toErrorWithMessage from 'utilities/getErrorMessage';

const prepareTaskTypePayload = ({
  task_type
}: ITaskTypePayload): ITaskTypePayload => {
  const { areas: _areas, ...taskTypeAttributes } = task_type;

  return { task_type: taskTypeAttributes };
};

export const getTaskType = (id: number) => {
  try {
    return request<ITaskTypeResponse>({
      options: {
        url: `/task_types/${id}`,
        method: 'get'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const getTaskTypes = () => {
  try {
    return request<ITaskTypesResponse>({
      options: {
        url: '/task_types',
        method: 'get'
      }
    });
  } catch (e) {
    return { data: [], pagination: {}, error: toErrorWithMessage(e) };
  }
};

export const createTaskType = (data: ITaskTypePayload) => {
  try {
    return request<ITaskTypeResponse>({
      options: {
        url: `/task_types`,
        method: 'post',
        data: prepareTaskTypePayload(data)
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const editTaskType = (id: number, data: ITaskTypePayload) => {
  try {
    return request<ITaskTypeResponse>({
      options: {
        url: `/task_types/${id}`,
        method: 'patch',
        data: prepareTaskTypePayload(data)
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const deleteTaskType = (id: number) => {
  try {
    return request<{}>({
      options: {
        url: `/task_types/${id}`,
        method: 'delete'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};
